module.exports = __webpack_public_path__ + "static/media/AD_RC.9cf8f88a.png";